import React, { Component } from 'react';
import { connect } from 'react-redux';
import { checkAuth } from "../actions/index";
import { LOGIN_LINK } from "../actions/types";

export default WrappedComponent => {
  class RequireAuth extends Component {
    componentWillMount(){
      if(!this.props.loading && !this.props.user){
        this.props.history.replace({ pathname: `${LOGIN_LINK}` ,state: { showTips: true }, });
      }
      this.props.checkAuth();
    }
    componentWillUpdate(nextProps) {
      if (!nextProps.loading && !nextProps.user) {
        this.props.history.replace({ pathname: `${LOGIN_LINK}` ,state: { showTips: true },});
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    const { user, error, loading } = state.auth;
    return { user, error, loading };
  }
  return connect(mapStateToProps, { checkAuth })(RequireAuth);
};
